export const profile = {
    name: "Aanish Amir Waseem",
    title: "Technical Lead | Senior Software Engineer | Mentor @ Udacity",
    email: "aanishamir@gmail.com",
    github: "https://github.com/Aanish97",
    linkedin: "https://www.linkedin.com/in/aanish-amir/",
    upwork: "https://www.upwork.com/freelancers/~01291bf56f628895ff",
    site: "https://aanish97.github.io/",
    punchLine: "I want to be part of an organization where my skills are utilized to the fullest, get the " +
        "opportunities to interact with a diverse community and learn advanced technologies!",
};

export const skills = [
    {
        category: "Backend & Frameworks",
        items: ["Python", "Django", "Django REST Framework", "Flask", "FastAPI", "Microservices Architecture"],
    },
    {
        category: "Frontend",
        items: ["React.js", "Next.js", "JavaScript (ES6+)", "jQuery", "CSS", "Sass", "Bootstrap"],
    },
    {
        category: "AI & Automation",
        items: ["Claude (Anthropic)", "LLM-Assisted Engineering", "Agentic Workflows", "Prompt Engineering"],
    },
    {
        category: "Cloud & DevOps",
        items: ["AWS", "Azure", "G-Cloud", "Docker", "Linux", "CI/CD", "Infrastructure Audits", "Cost Optimization"],
    },
    {
        category: "Data Engineering",
        items: ["ETL & Data Pipelines", "BigQuery", "Automation", "Real-time/Batch", "High-Volume Systems"],
    },
    {
        category: "Databases",
        items: ["PostgreSQL", "MySQL", "SQL Server"],
    },
    {
        category: "Security & Compliance",
        items: ["GDPR", "SOC-2", "ISO-27001"],
    },
    {
        category: "Additional",
        items: ["System Design", "Release Engineering", "Root Cause Analysis", "Team Leadership", "Performance Optimization", "Architecture Decisions"],
    },
];

export const experience = [
    {
        company: "Wizard Analytics",
        role: "Engineering Lead",
        time: "06/2025 - 02/2026",
    },
    {
        company: "Leonardo247",
        role: "Senior Software Engineer → Technical Team Lead",
        time: "06/2022 - 06/2025",
    },
    {
        company: "Esketchers",
        role: "Software Engineer → Senior Software Engineer",
        time: "06/2020 - 06/2022",
    },
];

export const projects = [
    {
        name: "Wizard Analytics",
        time: "06/2025 - 10/2025",
        bullets: [
            "Architected and deployed backend systems for SOV Wizard and Underwriter Wizard, automating insurance Statement of Values validation and reducing processing times from minutes to seconds.",
            "Led release management, code reviews, and cross-functional engineering decisions for enterprise clients.",
            "Improved data validation pipeline reliability by over 90% success rate through optimized microservices and error-handling flows.",
        ],
    },
    {
        name: "Leonardo247",
        time: "06/2022 – 06/2025",
        bullets: [
            "Solved a major race-condition issue after mapping and understanding a complex sync flow that previous teams couldn't resolve—restoring system reliability across all clientele.",
            "Optimized database queries and infrastructure, improving RDS write efficiency by more than 70% and reducing AWS RDS spend by over 30%.",
            "Eliminated bottlenecks in the data synchronization process, improving throughput by 9X.",
            "Owned release operations, hotfix calls, incident management, and RCA with stakeholder alignment.",
            "Mentored backend engineers, upheld coding standards, improved CI/CD pipelines, and increased deployment stability to 99.7%.",
        ],
    },
    {
        name: "Surmount AI (Contract)",
        time: "10/2022 – 04/2025",
        bullets: [
            "Led the entire frontend team and architected backend systems for Surmount AI's platform and white-label deployments.",
            "Conducted infrastructure audits & shut down unnecessary AWS resources, reducing cloud cost by 35%.",
            "Designed high-availability backend architecture and improved data pipeline throughput by 2× using optimized ETL workflows.",
            "Introduced new engineering protocols: code review workflows, deployment guidelines, versioning strategy, and monitoring standards—cutting downtime from server issues by 60%.",
        ],
    },
    {
        name: "The Linux Foundation (Open Source)",
        time: "12/2021 – 04/2023",
        bullets: [
            "Led microservice architecture across 3 open-source projects with 12+ community contributors.",
            "Built a GIS platform via the Google S2 API, enabling high-accuracy agricultural mapping & geospatial analytics.",
            "Developed a real-time chat system & reusable core microservices used across the open-source ecosystem.",
            "Established engineering standards, onboarding documentation, code review systems, and cross-region collaboration workflows.",
        ],
    },
];

export const education = [
    {
        degree: "MS Technology Management & Entrepreneurship",
        school: "LUMS",
        location: "Lahore, Pakistan",
        time: "2024 - 2025",
    },
    {
        degree: "BS Computer Science",
        school: "NUCES (FAST)",
        location: "Lahore, Pakistan",
        time: "2016 - 2020",
    },
    {
        degree: "O/A Level (Gold Medalist)",
        school: "Beaconhouse School System (BDC)",
        location: "Lahore, Pakistan",
        time: "2011 - 2016",
    },
];
